import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import RaffleLoginBox from './RaffleLoginBox';

class RaffleAuth extends React.Component {
  componentDidMount(){
    const { dataAuth } = this.props;
    if (dataAuth.isLogged) {
      this.props.history.replace("/promo/reactxdisruptor");
    }

  }
  render() {
    return (
      <RaffleLoginBox
        onBtnLoginClick={e=> this.props.history.replace({ pathname: '/login', search: "?next=/promo/reactxdisruptor" })}
        headerText="GET REACT NIKE ELEMENT 87 ANTRACITE AND FILA DISRUPTOR II FOR RETAIL PRICE"
        footerText="Refresh this page if you have successfully registered / logged in on the website."
      />
    )
  }
}

const mapStateToProps = state => ({
  dataAuth : state.dataAuth
})

export default connect(mapStateToProps, null)(RaffleAuth);
